(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ImpegnoDeleteController',ImpegnoDeleteController);

    ImpegnoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Impegno'];

    function ImpegnoDeleteController($uibModalInstance, entity, Impegno) {
        var vm = this;

        vm.impegno = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Impegno.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
